<template>
  <div class="studio-page--widget">
    <div class="container text-center">
      <div class="row" v-if="isLoading">
        <div class="col-12 mt-3">
          <HMSpinner />
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-12 position-static">
          <FullEventsCalendar
            :calendarEvents="calendarEvents"
            :openInNewWindow="true"
            template="widget"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import FullEventsCalendar from '@/web/components/events/FullEventsCalendar';
import { errorToMessage } from '../../../core/utils/errors';
import RefreshData from '@/web/mixins/refreshData';
import { getStudioURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'WidgetFullCalendar',
  mixins: [RefreshData],
  components: {
    FullEventsCalendar,
  },
  computed: {
    ...mapGetters({
      calendarEvents: 'studio/studioEvents',
      studio: 'studio/currentStudio',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
  },
  data() {
    return {
      isLoading: true,
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;
      try {
        await this.$store.dispatch('studio/getStudioEvents', this.studioURL);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load studio events',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  async mounted() {
    await this.loadData();
    window.Intercom('update', { hide_default_launcher: true });
  },
});
</script>

<style scoped></style>
